import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Timer.scss";
import api from "../../api/axiosInstance.js";

function Timer({ timeSpent }) {

  const [globalSeconds, setGlobalSeconds] = useState(timeSpent);
  const [seconds, setSeconds] = useState(timeSpent);
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);
  const navigate = useNavigate();
  const { id } = useParams();

  const stopAssessment = async () => {
    try {
      const response = await api.patch(`/api/candidate-assessments/time?candidateAssessmentId=${id}`, { time: globalSeconds });
      const data = response.data;
      console.log(data);
      navigate("/candidate/dashboard");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setGlobalSeconds((prev) => prev + 1);
    }, 1000);
    if(seconds === 60){
      setSeconds(0)
    }else{
      setSeconds(prev => prev + 1)
    }
    
    setMinutes(Math.floor(globalSeconds / 60))
    setHours(Math.floor(globalSeconds / 3600))
    return () => clearInterval(interval);
  }, [globalSeconds]);

  
  return (
    <div className="timer">
      <div className="value">
        <span>
          <strong>Time Spent: </strong>
        </span>
        <span className="value">
          {hours  >= 1 ? hours : "0"}h:{minutes >= 1 ? minutes : "0"}m:{seconds}s
        </span>
      </div>
      <button onClick={stopAssessment} className="secondary-button">
        Stop Assessment
      </button>
    </div>
  );
}

export default Timer;
